import { observer, useViewModel } from '@descomplica/microfrontend-react';
import * as pdfMake from 'pdfmake/build/pdfmake';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import {
  getMicroCertificateDocumentDefinition,
  pdfFonts,
  printPdf,
} from '@/application/utils/pdf-make/certificate-pdf.pdfmaker';
import Loading from '@/presentation/components/loading';

import { CertificatePublicViewModel } from './certificate-public.vm';

const Container = styled.div`
  width: 100%;
  font-family: 'Aprova Nova';
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: normal;
  color: #111;
  border-radius: 8px;
  position: relative;
  height: auto;
  min-height: 100vh;
`;

const CertificateSection = styled.div`
  background-color: #cacdce;
  width: 100%;
  height: 100vh;
`;

const CertificatePreviewContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const CertificatePublic: React.FC = () => {
  const vm = useViewModel(CertificatePublicViewModel);
  const [url, setUrl] = useState('');
  const { guid } = useParams();

  useEffect(() => {
    const createCertificateURL = async (): Promise<void> => {
      if (guid) {
        await vm.handleScreenCertificate(guid);

        const buildCertificatePublicUrl = (guid: string) => {
          return location.protocol + '//' + location.hostname + `/certificate/public/${guid}`;
        };

        const document = await getMicroCertificateDocumentDefinition(
          vm.certificate,
          buildCertificatePublicUrl(guid),
        );
        pdfMake.createPdf(document, undefined, pdfFonts).getDataUrl((url) => {
          setUrl(url);
        });
      }
    };
    void createCertificateURL();
  }, [guid]);

  if (vm.isLoading) {
    return <Loading />;
  }
  if (url) printPdf(url);

  return (
    <Container>
      <CertificateSection>
        <CertificatePreviewContainer id="print" />
      </CertificateSection>
    </Container>
  );
};

export default observer(CertificatePublic);
